// eslint-disable-next-line no-undef
const APPLICATION_NAME = APP_NAME;
export default APPLICATION_NAME;
